export enum GameDrawType {
	RANDOM = 'random-game',
	WIN_INSTANT = 'win-instant-game',
}
